export default {
  phoneNumber: '1-866-687-8789',
  emailInfo: 'info@trustscience.com',
  emailSupport: 'support@trustscience.com',
  emailReport: 'support+report@trustscience.com',
  emailOptOut: 'support+optout@trustscience.com',
  emailConsent: 'support+consent@trustscience.com',
};
